import React from "react";

const WORDS = [
  "Moving & Delivery Made Easy",
  "On Time, Every Time",
  "Fully Insured",
  "Belfast · Northern Ireland · UK",
];

export default function Marquee() {
  const items = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      className="relative bg-[var(--jb-navy)] text-[var(--jb-bone)] py-10 md:py-14 overflow-hidden border-y border-[var(--jb-navy-2)]"
      data-testid="marquee-section"
    >
      <div className="marquee whitespace-nowrap will-change-transform">
        {items.map((w, i) => (
          <span
            key={i}
            className="serif text-[clamp(48px,7vw,116px)] leading-none tracking-tight mx-8 flex items-center"
          >
            {w}
            <span className="ml-8 inline-block text-[var(--jb-rust)]">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
